import { user } from 'core';
import { history } from 'core/use-cases/utilities';
import { noticeError } from 'core/utilities/helpers/notice-error';
import type { CreditCardError } from './CreditCard.d';

export const useCreditCardError = () => {
  const {
    data: { resellerId },
  } = user.hooks.useUser();

  const errorFlow = (step: string, statusCode = 0, detail = '', errorType = '') => {
    const data = {
      detail,
      errorType,
      resellerId,
      statusCode,
      step,
    };

    noticeError<CreditCardError>('credit-card-error', data);

    if (statusCode === 401) {
      history.push('/401');
    }
  };

  return { errorFlow };
};
